<template>
  <!-- 品牌红包抽奖 -->
  <van-popup v-model="showPrize" :close-on-click-overlay="false" @click-overlay="$emit('close')" :lock-scroll="false">
    <!-- 中奖 -->
    <div class="logo-prize" v-if="lotteryResult.category !== 'thanks'">
      <!-- 现金 -->
      <div v-if="lotteryResult.category === 'redpack'">
        <div class="red-box">
          <div class="logo-money">{{ lotteryResult.value }}元</div>
          <div class="logo-remark">现金红包</div>
          <img src="@this/assets/image-25.png" @click="$emit('close')" class="red-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
      <!-- 链接 -->
      <div class="link" v-if="lotteryResult.category === 'link'">
        <div class="link-box">
          <div class="logo-link">{{ lotteryResult.name }}</div>
          <img src="@this/assets/image-22.png" @click="$emit('clickConfirm')" class="link-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
      <!-- logo -->
      <div class="lg" v-if="lotteryResult.category === 'card'">
        <div class="lg-title" v-if="lotteryResult.type === 'special'">圣诞卡</div>
        <div class="lg-title" v-else>品牌卡</div>
        <img :src="lotteryResult.cardImg" class="lg-logo" />
        <img src="@this/assets/image-22.png" @click="$emit('close')" class="lg-get" />
      </div>
    </div>
    <!-- 未中奖 -->
    <div class="logo-no" v-else>
      <img src="@this/assets/image-25.png" @click="$emit('close')" class="logo-btn" />
      <img :src="prizePicture" alt="" class="logo-coupon" />
    </div>
    <div @click="$emit('close')" class="popup-close-blue"></div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    showPrize: {
      type: Boolean,
      default: false,
    },
    lotteryResult: {
      type: Object,
      default() {
        return {};
      },
    },
    prizePicture: {
      type: String,
      default: '',
    },
  },
  components: {
    [Popup.name]: Popup,
  },
  methods: {
    gotoLink(link) {
      this.$emit('gotoLink', link);
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-no-count {
  background-size: 100% 100%;
  width: 617px;
  height: 480px;
  position: relative;
  img {
    width: 347px;
    height: 103px;
    position: absolute;
    left: 118px;
    top: 320px;
  }
}
.logo-box {
  background-size: 100% 100%;
  width: 617px;
  height: 480px;
  position: relative;
  img {
    width: 347px;
    height: 103px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 320px;
  }
}
.logo-no {
  background: url(~@this/assets/image-33.png) no-repeat;
  background-size: 100% 100%;
  width: 577px;
  height: 661px;
  position: relative;
  .logo-btn {
    width: 321px;
    height: 83px;
    position: absolute;
    left: 50%;
    top: 335px;
    transform: translate(-50%);
  }
  .logo-coupon {
    width: 515px;
    height: 197px;
    position: absolute;
    left: 50%;
    top: 440px;
    transform: translate(-50%);
  }
}
.logo-prize {
  background: url(~@this/assets/image-30.png) no-repeat;
  background-size: 100% 100%;
  width: 577px;
  height: 661px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .red-box {
    background: url(~@this/assets/image-29.png) no-repeat;
    background-size: 100% 100%;
    width: 515px;
    height: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translate(-50%);
    .red-btn {
      position: absolute;
      left: 50%;
      top: 220px;
      transform: translate(-50%);
      width: 321px;
      height: 83px;
    }
  }
  .logo-money {
    margin-top: 40px;
    font-size: 95px;
    font-weight: 600;
    color: #ff4040;
  }
  .logo-remark {
    margin-top: 15px;
    color: #1a524f;
    font-weight: 800;
    font-size: 32px;
  }
  .logo-coupon {
    width: 515px;
    height: 197px;
    position: absolute;
    left: 50%;
    top: 440px;
    transform: translate(-50%);
  }
  .link {
    .link-box {
      background: url(~@this/assets/image-29.png) no-repeat;
      background-size: 100% 100%;
      width: 515px;
      height: 270px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 120px;
      transform: translate(-50%);
      .logo-link {
        margin-top: 90px;
        font-size: 50px;
        font-weight: 600;
        color: #ff4040;
      }
      .link-btn {
        position: absolute;
        left: 50%;
        top: 220px;
        transform: translate(-50%);
        width: 321px;
        height: 83px;
      }
    }
  }
  .lg {
    background: url(~@this/assets/image-32.png) no-repeat;
    background-size: 100% 100%;
    width: 515px;
    height: 477px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 125px;
    transform: translate(-50%);
    .lg-title {
      margin-top: 50px;
      color: #fe5455;
      font-weight: 800;
      font-size: 40px;
    }
    .lg-logo {
      margin: 40px 0;
      width: 215px;
      height: 254px;
    }
    .lg-get {
      position: absolute;
      left: 50%;
      top: 430px;
      transform: translate(-50%);
      width: 321px;
      height: 83px;
    }
  }
}
</style>
